const defaults = {
  COMPANY_NAME: "Best Coast Pairings",
  APP_NAME: "BCP",
  SYSTEM_IMAGES_CLOUDFRONT: "",
  STYLESHEET: "stylesheet1",
  SCOPE: '[{ "type": "cognito" }]',
};

export function getEnvironmentVariable(suffix) {
  let value = undefined;
  if (window.location?.hostname === "localhost") {
    value = process.env[`REACT_APP_LOCAL_${suffix}`];
    if (value === "NOT SET") {
      value = undefined;
    } else if (value !== undefined) {
      return value;
    }
  }

  value = process.env[`REACT_APP_${suffix}`];
  if (value === undefined || value === "NOT SET") {
    return defaults[suffix];
  }

  return value;
}
